export const languages = {
  fr: 'fr',
  en: 'en',
  tr: 'tr',
  ru: 'ru',
  it: 'it',
  fa: 'fa',
  ar: 'ar',
  pt: 'pt',
  es: 'es',
  zh: 'zh',
};